module.exports = __webpack_public_path__ + "img/logo.5ec5ac61.svg";